import getSelectedTicketTypes from './getSelectedTicketTypes';

export default function getTicketTypeValues(
  checkoutTicketGroups,
  formTicketGroups,
) {
  const selectedTicketTypes = getSelectedTicketTypes(
    checkoutTicketGroups,
    formTicketGroups,
  );

  return selectedTicketTypes.reduce((obj, ticketType) => {
    obj[ticketType._id] = ticketType?.quantity;

    return obj;
  }, {});
}
